import React from 'react';
import DirectReports from './DirectReports';
import FlipProfilePhoto from '../../components/FlipProfilePhoto';
import Count from './Count';
import { getActive } from './data';
import { OrgChart } from '../../types';

interface ActiveProps {
  active: string;
  value: OrgChart;
  onClick: (id: string) => void;
}

export default function Active({ active, value, onClick }: ActiveProps) {
  const current = getActive(active, value);

  if (!current) return 'Not active';

  return (
    <div className="orgchart-active">
      <div className="orgchart-card">
        <div className="orgchart-card-info-count">
          <div className="orgchart-card-info">
            <div className="orgchart-card-info-photo">
              <FlipProfilePhoto
                firstName={current.firstName}
                lastName={current.lastName}
                id={active}
              />
            </div>
            <div className="orgchart-card-info-profile">
              <h1>{`${current.firstName} ${current.lastName}`}</h1>
              <h2>{current.title}</h2>
            </div>
          </div>
          <Count total={current.reports.length} />
        </div>
        <div className="orgchart-card-actions">
          <button type="button" className="btn">Message</button>
        </div>
      </div>
      <DirectReports active={active} value={value} onClick={onClick} />
    </div>
  );
}
